// TODO: Move this copy into the app's translation system when one is available.
export const disabledActionMessages = {
  context: 'Job or user information is unavailable.',
  organizationContext: 'Organization information is unavailable.',
  confirmationsDisabled: 'Stop confirmations are disabled for this job.',
  executionStatus: 'The job must be active, paused, or completed.',
  role: 'A dispatcher or admin role is required.',
  assignedProvider: 'Your organization is not the assigned service provider.',
  approved: 'This job has been approved.',
  completed: 'Stops cannot be deleted after the job is completed.',
  receiptOwner: 'This receipt belongs to another organization.',
  stopOwner: 'This stop was created by another organization.',
  deleting: 'A deletion is already in progress.',
  locationOwner: 'Your organization does not own this location.',
  locationLoading: 'Checking location ownership…',
  locationError: 'Location ownership could not be verified.',
} as const
